import { Group } from "../api/group";
export const group = (attribs = {}, children) => new Group(attribs, children);
